import React, { FC, useCallback } from 'react';
import clsx from 'classnames';
import { Button } from 'common/button';
import { useCloseModal } from 'state/modal';
import { ConfirmMessageContentPreset } from './confirm-message-content.preset';
import { ConfirmMessageContentProps } from './confirm-message-content.types';

import styles from './confirm-message-content.module.scss';

export const ConfirmMessageContent: FC<ConfirmMessageContentProps> = props => {
  const { id, message, onConfirm } = { ...ConfirmMessageContentPreset, ...props };
  const { closeModal } = useCloseModal();

  const closeFn = useCallback(() => {
    closeModal(id as string);
  }, []);

  const confirmFn = useCallback(() => {
    onConfirm?.();
    closeModal(id as string);
  }, []);

  return (
    <div className={styles.container}>
      <div className="pb-2 lg:pb-0">
        <p className={clsx('text-justify pb-2', styles.message)}>{message}</p>
      </div>

      <div className="text-center pt-4 flex justify-center items-center gap-4">
        <Button label="Cancelar" theme="outline" onClick={closeFn} />
        <Button label="Aceptar" onClick={confirmFn} />
      </div>
    </div>
  );
};

export default React.memo(ConfirmMessageContent);
